import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { formatLaoPayout } from '../../utils/laoUtils';

export function LaoHowToPlay({ config }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">วิธีดูบน-ล่าง</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-sm text-gray-600">
        <p>
          ออก {config?.scheduleLabel || 'จันทร์ พุธ ศุกร์ 20:00 น.'}{' '}
          ปิดรับ 15 นาทีก่อนออก
        </p>
        <p>
          ผล 6 ตัว เช่น <span className="font-mono font-bold text-brand-red">1 3 3 8 1 6</span>
        </p>
        <div className="flex justify-center gap-1 font-mono text-lg font-black">
          {['1', '3', '3', '8', '1', '6'].map((digit, index) => {
            const isBottom = index === 2 || index === 3;
            const isTop = index >= 3;
            return (
              <span
                key={`${digit}-${index}`}
                className={`flex h-10 w-8 items-center justify-center rounded-lg border-2 ${
                  isBottom && isTop
                    ? 'border-brand-gold bg-amber-100 text-brand-red'
                    : isBottom
                      ? 'border-brand-gold bg-brand-gold text-red-950'
                      : isTop
                        ? 'border-brand-red bg-white text-brand-red'
                        : 'border-gray-200 bg-gray-50 text-gray-400'
                }`}
              >
                {digit}
              </span>
            );
          })}
        </div>
        <ul className="space-y-1">
          <li>
            3 ตัวบน = <strong className="font-mono">816</strong>
          </li>
          <li>
            2 ตัวบน = <strong className="font-mono">16</strong>
          </li>
          <li>
            2 ตัวล่าง = <strong className="font-mono">38</strong> (หน้าของเลข 4
            ตัวท้าย)
          </li>
        </ul>
        {config?.betTypes ? (
          <div className="space-y-1 border-t border-red-50 pt-3">
            {config.betTypes.map((item) => (
              <div key={item.id} className="flex justify-between gap-2">
                <span>{item.label}</span>
                <span className="font-semibold text-brand-gold">
                  {formatLaoPayout(item.multiplier)}
                </span>
              </div>
            ))}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
